export default __webpack_public_path__ + "static/media/Promotion_img_En.d1561210.webp";